import { render, staticRenderFns } from "./InfoState.vue?vue&type=template&id=383b07f6&scoped=true"
import script from "./InfoState.vue?vue&type=script&lang=js"
export * from "./InfoState.vue?vue&type=script&lang=js"
import style0 from "./InfoState.vue?vue&type=style&index=0&id=383b07f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b07f6",
  null
  
)

export default component.exports